import { cn } from "utils/helpers";
import { EvaluationPanelMember, PanelMemberWithProgress } from "../../types/panel.type";

export interface DisclaimerBadgeConfig {
	classes: string;
	label: string;
}

type DisclaimerStatus = "no_conflict" | "conflict" | "reviewed" | null | undefined;
type DisclaimerReviewAction = "accepted" | "revoked" | null | undefined;

const pendingBadge = { label: "Pending", classes: "bg-gray-100 text-gray-600" };

const getDisclaimerBadge = (
	status: DisclaimerStatus,
	reviewAction?: DisclaimerReviewAction
): DisclaimerBadgeConfig => {
	switch (status) {
		case "no_conflict":
			return { label: "No Conflict", classes: "bg-green-100 text-green-700" };
		case "conflict":
			return { label: "Conflict", classes: "bg-red-100 text-red-700" };
		case "reviewed":
			return { label: "Conflict", classes: "bg-red-100 text-red-700" };
		default:
			return pendingBadge;
	}
};

const getReviewBadge = (status: DisclaimerStatus, reviewAction?: DisclaimerReviewAction): DisclaimerBadgeConfig | null => {

	if (status !== "conflict" && status !== "reviewed") {
		return null;
	}

	if (status === "conflict") {
		return pendingBadge;
	}

	return reviewAction === "revoked" ? { label: "Revoked", classes: "bg-red-100 text-red-700" }
		: { label: "Reviewed", classes: "bg-green-100 text-green-700" };
}

interface MemberDisclaimerTableCellProps {
	member: EvaluationPanelMember | PanelMemberWithProgress;
}


export const MemberDisclaimerTableCell = ({ member }: MemberDisclaimerTableCellProps) => {
	const disclaimerBadge = getDisclaimerBadge(member.disclaimer_status, member.disclaimer_review_action);
	const reviewBadge = getReviewBadge(member.disclaimer_status, member.disclaimer_review_action);
	return <div className="flex flex-col items-start gap-2">
		<span
			className={cn(
				"inline-flex rounded-full px-2 py-0.5 text-xs font-medium",
				disclaimerBadge.classes
			)}
			data-testid="disclaimer-status-badge"
		>
			{disclaimerBadge.label}
		</span>
		{reviewBadge && <span
			className={cn(
				"inline-flex rounded-full px-2 py-0.5 text-xs font-medium",
				reviewBadge.classes
			)}
			data-testid="disclaimer-status-badge"
		>
			{reviewBadge.label}
		</span>}
	</div>
}